import { render, staticRenderFns } from "./BtnConfirm.vue?vue&type=template&id=73814db7&"
import script from "./BtnConfirm.vue?vue&type=script&lang=js&"
export * from "./BtnConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports